import React, { ReactNode, useMemo } from "react";
import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";

import { IFormantTheme } from "../../../style/IFormantTheme";
import { FormantMaterialTheme } from "./FormantMaterialTheme";
import { DarkPalette, LightPalette } from "./themeDefaults";

function getThemeValues(mode: "dark" | "light" | IFormantTheme): IFormantTheme {
    if (typeof mode === "object") {
        return mode;
    }
    return mode !== "dark" ? LightPalette : DarkPalette;
}

interface IThemeProps {
    scoped?: boolean;
    mode: "dark" | "light" | IFormantTheme;
    children?: ReactNode;
}

const formantCache = createCache({
    key: "formant",
    /* FIXME need to inject emotion css *before* styled-component generated css.
     * This will go away once all of the existing styled-component components
     * have been converted.
     */
    insertionPoint:
        document.querySelector<HTMLElement>("head > title") ?? undefined,
});

export const Theme = (props: IThemeProps) => {
    const { mode, scoped = false, children } = props;
    const theme = useMemo(() => getThemeValues(mode), [mode]);
    return (
        <CacheProvider value={formantCache}>
            <ThemeProvider theme={theme}>
                <FormantMaterialTheme scoped={scoped}>
                    {children}
                </FormantMaterialTheme>
            </ThemeProvider>
        </CacheProvider>
    );
};
